import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Modal, Input } from 'antd';
import OTextArea from '../common/TextArea';
const { TextArea } = Input;

class AddReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      content: {}
    }
  }

  componentWillMount() {

  }

  getContentById = (key) => {
    if(!this.props.weekReport){
      return ''
    }
    for (let r in this.props.weekReport.content) {
      let r = JSON.parse(this.props.weekReport.content[r]);
      if (r.k && r.k.toString() == key.toString()) {
        return r.v || '';
      }
    }
  }

  componentWillReceiveProps(props) {

    const initContent = {};
    if (props.visible !== this.props.visible && props.visible === true) {


      this.props.reportTemplate.templateQuestions.map((t) => {
        initContent[t.title] = this.getContentById(t.title);
      });
      console.log('initContent:::::', initContent);
      this.setState({ content: Object.assign({}, this.state.content, initContent) });
    }
  }

  componentDidUpdate(props) {

  }



  onChangeValue = (value, qid) => {
    this.setState({ content: Object.assign({}, this.state.content, { [qid]: value }) });
    //this.setState({ content: Object.assign({}, this.state.content, { [qid]: value.target.value }) });
  }

  handleOk = () => {
    if (this.props.handleOk) {
      var parames = [];
      for (var key in this.state.content) {
        let val = {
          k: key,
          v: this.state.content[key]
        }
        parames.push(JSON.stringify(val));
      }
      return this.props.handleOk(parames);
    }
  }

  render() {
    const { visible, handleCancel, reportTemplate, weekReport } = this.props;
    return (
      <Modal
        title={weekReport ? '编辑周报' : '添加周报'}
        visible={visible}
        onOk={this.handleOk}
        okText={this.state.okText}
        cancelText='取消'
        onCancel={handleCancel}
        maskClosable={false}
        width={850}
      >
        <div className="add-okr-view">
          {
            reportTemplate.templateQuestions.map((t) => {
              return (
                <section key={t.title}>
                  <p className="report-add">{t.title}</p>
                  {/* <Input type="textarea"
                    autosize={{ minRows: 4, maxRows: 6 }}
                    value={this.state.content[t.title]}
                    onChange={(e, v) => this.onChangeValue(e, t.title)}
                  /> */}
                   <OTextArea visible={visible} defaultValue={this.state.content[t.title]} onChange={this.onChangeValue} qid={t.title} /> 
                </section>
              )
            })
          }
        </div>
      </Modal>
    )
  }
}

function mapStateToProps({ okrObjectives, page }) {
  return {};
}
const mapDispatchToProps = (dispatch) => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AddReport)


// WEBPACK FOOTER //
// ./src/components/okr_manage/add_report.js